import React from 'react';
//import SourceLink from 'components/SourceLink';
import { MdBuild, MdGroup, MdMyLocation } from 'react-icons/md';
import { NavLink } from 'react-router-dom';
import {
  // UncontrolledTooltip,
  Collapse,
  Nav,
  Navbar,
  NavItem,
  NavLink as BSNavLink,
} from 'reactstrap';

const navItems = [
  // { to: '/', name: 'Dashboard', exact: true, Icon: MdDashboard },
  {
    to: '/person',
    name: 'Person',
    exact: true,
    Icon: MdGroup,
  },
  {
    to: '/site',
    name: 'Site',
    exact: true,
    Icon: MdMyLocation,
  },
  {
    to: '/configuration',
    name: 'Configuration',
    exact: true,
    Icon: MdBuild,
  },
  // { to: '/', name: 'Dashboard', exact: true, Icon: MdDashboard },
  // { to: '/cards', name: 'Cards', exact: false, Icon: MdWeb },
  // { to: '/charts', name: 'Charts', exact: false, Icon: MdInsertChart },
  // { to: '/widgets', name: 'Widgets', exact: false, Icon: MdWidgets },
];

class Appbar extends React.Component {
  render() {
    return (
      <aside className="ps-appbar">
        <Nav vertical>
          {navItems.map(({ to, name, exact, Icon }, index) => (
            <NavItem key={index}>
              <BSNavLink
                id={`navItem-${name}-${index}`}
                tag={NavLink}
                to={to}
                activeClassName="active"
                exact={exact}
              >
                <Icon />
              </BSNavLink>
            </NavItem>
          ))}
        </Nav>
      </aside>
    );
  }
}

export default Appbar;
